import React from 'react';
import { createRoot } from 'react-dom/client';
import { initI18n } from '@plerionhq/design-system/i18n';
import { App } from './App';
import { reloadOnStaleChunk } from './lib/chunk-reload';

// One i18next instance for the whole bundle.
initI18n();

// Recover when a lazy-loaded chunk fails to load (see
// ./lib/chunk-reload.ts for the full explanation). Vite fires `vite:preloadError`
// whenever any dynamic import fails, so this one listener covers every
// lazy-loaded page/component — we don't need to touch each import. The handler
// reloads the page once (guarded against loops) to pick up the new build.
//
// Important: we do NOT call `event.preventDefault()`. If we did, Vite would
// hide the failure and hand React.lazy an `undefined` module, which then throws
// a confusing "Cannot read properties of undefined" error. By letting the error
// through, it reaches our error boundary, which shows a clear message if the
// reload didn't fix things.
window.addEventListener('vite:preloadError', () => {
  reloadOnStaleChunk();
});

const container = document.querySelector('#plerion-microfrontend-root');
if (!container) {
  throw new Error("'#plerion-microfrontend-root element doesn't exists");
}
const root = createRoot(container);
root.render(<App />);
